export default __webpack_public_path__ + "static/media/oe-3-lqMAX.2226a8b1.jpg";